module.exports = __webpack_public_path__ + "media/newstyle/images/mastercard-c648f9dd708fb4892045c3056ca7f594.svg";